import { render, staticRenderFns } from "./AmcContractForm.vue?vue&type=template&id=4480e88f&scoped=true&"
import script from "./AmcContractForm.vue?vue&type=script&lang=js&"
export * from "./AmcContractForm.vue?vue&type=script&lang=js&"
import style0 from "./AmcContractForm.vue?vue&type=style&index=0&id=4480e88f&scoped=true&lang=css&"
import style1 from "./AmcContractForm.vue?vue&type=style&index=1&id=4480e88f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480e88f",
  null
  
)

export default component.exports